<div class="modal-header">
    <h4 class="modal-title">Submit for Approval</h4>
</div>
<div class="modal-body">
    <p>All user requirements have been met for this item. Would you like to submit for approval?</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="activeModal.close('confirm')">Submit For Approval</button>
    <button type="button" class="btn btn-info" (click)="activeModal.dismiss('cancel')">No</button>
</div>